import { useCallback, useState } from 'react';
import type { RTPGrouping } from '@/types/rtpDownload';

interface TimeRange {
  from: string | null;
  to: string | null;
}

interface UseRTPDownloadConfigResult {
  timeRange: TimeRange;
  grouping: RTPGrouping;
  onTimeRangeChange: (from: string | null, to: string | null) => void;
  onGroupingChange: (grouping: RTPGrouping) => void;
  hasTimeRange: boolean;
}

export function useRTPDownloadConfig(
  initialGrouping: RTPGrouping = 'day'
): UseRTPDownloadConfigResult {
  const [timeRange, setTimeRange] = useState<TimeRange>({
    from: null,
    to: null,
  });
  const [grouping, setGrouping] = useState<RTPGrouping>(initialGrouping);

  const onTimeRangeChange = useCallback((from: string | null, to: string | null) => {
    setTimeRange({ from, to });
  }, []);

  const onGroupingChange = useCallback((newGrouping: RTPGrouping) => {
    setGrouping(newGrouping);
  }, []);

  const hasTimeRange = Boolean(timeRange.from && timeRange.to);

  return {
    timeRange,
    grouping,
    onTimeRangeChange,
    onGroupingChange,
    hasTimeRange,
  };
}
